import React from 'react';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import VoyagerSearchDetailsPageBlockView from './VoyagerSearchDetailsPageBlock';
import VoyagerSearchDetailsPageBlockSchema from './VoyagerSearchDetailsPageBlockSchema';
import type { VoyagerSearchDetailsPageBlockProps } from './models/detail-item';

type VoyagerSearchDetailsPageBlockEditProps =
  VoyagerSearchDetailsPageBlockProps & {
    block: string;
    selected?: boolean;
    onChangeBlock: (block: string, data: Record<string, unknown>) => void;
  };

const VoyagerSearchDetailsPageBlockEdit: React.FC<
  VoyagerSearchDetailsPageBlockEditProps
> = (props) => {
  const { data, block, onChangeBlock, selected } = props;

  return (
    <>
      <VoyagerSearchDetailsPageBlockView {...props} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={VoyagerSearchDetailsPageBlockSchema}
          title={VoyagerSearchDetailsPageBlockSchema.title}
          onChangeField={(id: string, value: unknown) => {
            onChangeBlock(block, {
              ...(data || {}),
              [id]: value,
            });
          }}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

export default VoyagerSearchDetailsPageBlockEdit;
